/**
* Get "rtl" or "ltr" from <html dir="">
* Returns either 'ltr' or 'rtl'
*
*/
function layoutDirection() {
	var htmlElement = document.querySelectorAll('html')[0];
	return htmlElement.getAttribute('dir') || 'ltr';
}

/**
* Debounce, taken from lodash
* @param func function to debounce
* @param wait time in milliseconds
*
*/
function debounce(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this;
		var args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) {
				func.apply(context, args);
			}
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) {
			func.apply(context, args);
		}
	};
}

/**
* Listen for touchstart event
*
*/
function initTouchstart() {
	document.addEventListener('touchstart', function() {}, true);
}

/**
 * Replace a parameter value in a URL
 * https://stackoverflow.com/questions/7171099/how-to-replace-url-parameter-with-javascript-jquery
 */
function replaceUrlParam(url, paramName, paramValue) {
	if (paramValue == null) {
		paramValue = '';
	}
	var pattern = new RegExp('\\b('+paramName+'=).*?(&|$)');
	if (url.search(pattern) >= 0) {
		return url.replace(pattern,'$1' + paramValue + '$2');
	}
	url = url.replace(/\?$/,'');
	return url + (url.indexOf('?')>0 ? '&' : '?') + paramName + '=' + paramValue;
}

/**
 * Remove a parameter in a URL
 * https://stackoverflow.com/questions/16941104/remove-a-parameter-to-the-url-with-javascript
 */
function removeUrlParam(url, paramName) {
	var rtn = url.split('?')[0];
	var	param;
	var	params_arr = [];
	var	queryString = (url.indexOf('?') !== -1) ? url.split('?')[1] : '';
	if (queryString !== '') {
		params_arr = queryString.split('&');
		for (var i = params_arr.length - 1; i >= 0; i -= 1) {
			param = params_arr[i].split('=')[0];
			if (param === paramName) {
				params_arr.splice(i, 1);
			}
		}
		if (params_arr.length) {
			rtn = rtn + '?' + params_arr.join('&');
		} else {
			rtn = rtn;
		}
	}
	return rtn;
}

/**
 * Polyfill for sending custom events
 * needed for IE 11
 * https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent
 */
(function () {

	if ( typeof window.CustomEvent === "function" ) return false;

	function CustomEvent ( event, params ) {
	params = params || { bubbles: false, cancelable: false, detail: undefined };
	var evt = document.createEvent( 'CustomEvent' );
	evt.initCustomEvent( event, params.bubbles, params.cancelable, params.detail );
	return evt;
	}

	CustomEvent.prototype = window.Event.prototype;

	window.CustomEvent = CustomEvent;
})();


// Create Element.remove() function if not exist
if (!('remove' in Element.prototype)) {
    Element.prototype.remove = function() {
        if (this.parentNode) {
            this.parentNode.removeChild(this);
        }
    };
}
